/**
 * One case's scores, one row per chosen evaluator: its score (or why it has
 * none) and its reason. Shared by "Try one case" and "Test on one case".
 */

import { Markdown } from "@/components/ui/markdown";
import { Pill } from "@/components/ui/pill";
import { formatScore } from "@/lib/format";
import type { CaseScore } from "../types";

export function CaseScores({ scores, label }: { scores: CaseScore[]; label: string }) {
  return (
    <section aria-label={label}>
      <ul className="flex flex-col divide-y divide-line-soft rounded-[9px] border border-line">
        {scores.map((s) => (
          <li key={s.evaluator_id} className="flex items-start gap-3 px-3 py-2 text-[13px]">
            <span className="w-44 shrink-0 font-medium">{s.name}</span>
            <span className="w-24 shrink-0">
              {s.status === "scored" ? (
                <Pill tone={s.passed === false ? "err" : "run"}>{formatScore(s.value)}</Pill>
              ) : (
                <Pill tone="warn">{s.status.replace("_", " ")}</Pill>
              )}
            </span>
            <div className="min-w-0 text-xs text-muted">
              <Markdown>{s.reason ?? ""}</Markdown>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
